module.exports = __webpack_public_path__ + "static/natural-capitalism-20224405693b2d6dd48e0b81db6fb208.jpg";